import { Pipe, PipeTransform } from '@angular/core';
import { UserActionTypeAreaMap } from '@common/constants';

@Pipe({
  name: 'userNameTypeArea',
  pure: true
})
export class UserActionTypeAreaPipe implements PipeTransform {
  transform(key: string): string {
    return UserActionTypeAreaMap[key] ? UserActionTypeAreaMap[key].displayName : '';
  }
}
